import UserWidget from './UserWidget';

export default UserWidget;
